export default "__VITE_PUBLIC_ASSET__026a1afe__"